import React from 'react'
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
import { Grid, IconButton, InputAdornment, Popover, TextField } from '@mui/material';
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';

const InputMessage = (props) => {

    const { value, setValue, handleOnEnter } = props;

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);


    return (
        <>
            <Grid container direction="row" justifyContent="space-around" alignItems="center" >
                <Grid item xs={12}>
                    <TextField
                        id="inputchat"
                        label=""
                        value={value}
                        variant="outlined"
                        fullWidth={true}
                        autoComplete={"off"}
                        size='small'
                        placeholder={currentLanguage() === "th" ? "กรอกข้อความ" : "Enter input"}
                        onChange={(e) => {
                            setValue(e.target.value)
                        }}
                        inputProps={{
                            maxLength: 500,
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <IconButton
                                        style={{ padding: '0px' }}
                                        onClick={(event) => { setAnchorEl(event.currentTarget) }}
                                    >
                                        <EmojiEmotionsOutlinedIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx: {
                                borderRadius: "50rem"
                            },
                        }}
                        onKeyDown={(e) => {
                            if (e && e.key === "Enter") {
                                handleOnEnter(value)
                            }
                        }}
                        sx={[{
                            "label.MuiInputLabel-shrink": {
                                backgroundColor: "rgb(255 255 255 / 18%)",
                                // backgroundColor: "rgba(255,255,255,0.95)",
                                top: "0px",
                            },
                        }]}
                    />
                    <Popover
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => { setAnchorEl(null) }}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                    >
                        <Picker
                            data={data}
                            noCountryFlags={true}
                            perLine={7}
                            set={"native"}
                            emojiVersion={12}
                            categories={["people","nature","foods","activity","places","objects","symbols","flags"]}
                            skinTonePosition={"none"}
                            exceptEmojis={["relaxed","blush"]}
                            onEmojiSelect={(e) => {
                                if (e) {
                                    setValue(text => text + e.native)
                                }
                            }}
                        />
                    </Popover>
                </Grid>
            </Grid>

        </>


    )
}

export default InputMessage
